function bbModalWidget($compile, $q, $log, $templateCache) {

    'ngInject';

    const getTemplate = (template) => {
        const partial = template ? template : 'main';
        return $templateCache.get(partial + '.html');
    };

    const renderTemplate = (scope, element, designMode, template) => {
        $q.when(getTemplate(template))
            .then(templateFromCache => showTemplate(scope, element, designMode, templateFromCache))
            .catch(() => $log.info('template not found in cache')
        );
    };

    const showTemplate = (scope, element, designMode, template) => {
        element.html(template).show();
        if (designMode) {
            element.append('<style widget_css scoped></style>');
        }
        $compile(element.contents())(scope);
    };


    const link = (scope, element) => {
        const config = scope.config;
        scope.initWidget(config);
        return renderTemplate(scope, element, config.design_mode, config.template);
    };


    return {
        link,
        controller: 'BBCtrl',
        controllerAs: '$bbCtrl',
        scope: {
            config: '='
        }
    };
}

angular.module('BB').directive('bbModalWidget', bbModalWidget);




// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/widget-modal/bb_widget_modal.directive.js